import { BundleResourcesPackage } from "resource-system";
import { Texture } from "@pixi/core";
export class SpineResourcesPackage extends BundleResourcesPackage {
    public constructor() {
        super("SpineResourcesPackage");
    }
    public get assets_spine_coin_coin_glow_atlas(): any {
        return this.resource<any>("assets/spine/coin/coin_glow.atlas");
    }
    public get assets_spine_coin_coin_glow_json(): Object {
        return this.resource<Object>("assets/spine/coin/coin_glow.json");
    }
    public get assets_spine_coin_coin_glow_png(): Texture {
        return this.resource<Texture>("assets/spine/coin/coin_glow.png");
    }
    public get assets_spine_confetti_confetti_atlas(): any {
        return this.resource<any>("assets/spine/confetti/confetti.atlas");
    }
    public get assets_spine_confetti_confetti_json(): Object {
        return this.resource<Object>("assets/spine/confetti/confetti.json");
    }
    public get assets_spine_confetti_confetti_png(): Texture {
        return this.resource<Texture>("assets/spine/confetti/confetti.png");
    }
    public get assets_spine_rotate_rotate_screen_animation_atlas(): any {
        return this.resource<any>("assets/spine/rotate/rotate_screen_animation.atlas");
    }
    public get assets_spine_rotate_rotate_screen_animation_json(): Object {
        return this.resource<Object>("assets/spine/rotate/rotate_screen_animation.json");
    }
    public get assets_spine_rotate_rotate_screen_animation_png(): Texture {
        return this.resource<Texture>("assets/spine/rotate/rotate_screen_animation.png");
    }
    public get assets_spine_victory_ad_button_shine_Button_X5_atlas(): any {
        return this.resource<any>("assets/spine/victory_ad_button_shine/Button_X5.atlas");
    }
    public get assets_spine_victory_ad_button_shine_Button_X5_json(): Object {
        return this.resource<Object>("assets/spine/victory_ad_button_shine/Button_X5.json");
    }
    public get assets_spine_victory_ad_button_shine_Button_X5_png(): Texture {
        return this.resource<Texture>("assets/spine/victory_ad_button_shine/Button_X5.png");
    }
}

